import "./index.css"

const BreadCrumbs = ({items}) => {

  return (
    <div className="breadcrumb-box">
      <ol className="breadcrumb">
        {items.map(item => (
          <li><a href={item.link || undefined}>{item.name}</a></li>
        ))}
      </ol>
    </div>
  )
}

export default BreadCrumbs;